module.exports = __webpack_public_path__ + "assets/img/shouye_shangpinyuding.8eed602e.svg";